import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';

export const AuthenticationLoginSchema = T.Object({
  email: T.String({ minLength: 1, maxLength: 80, error: 'email inválido', format: 'email' }),
  password: T.String({ minLength: 1, maxLength: 80, error: 'password inválido' }),
});

export type AuthenticationLoginInputType = typeof AuthenticationLoginSchema.static;

export async function ValidateAuthenticationLoginInput(value: unknown): Promise<AuthenticationLoginInputType> {
  return Value.Parse(AuthenticationLoginSchema, value);
}

export function checkAuthenticationLoginInput(field: string, value: unknown): string | boolean {
  return validateField(AuthenticationLoginSchema, field, value);
}
